import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBouncing3Dots = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 4,
			cy: 12,
			r: 3,
			fill: "currentColor",
			children: /* @__PURE__ */ _jsx("animate", {
				id: "svgSpinners3DotsBounce0",
				attributeName: "cy",
				begin: "0;svgSpinners3DotsBounce1.end+0.25s",
				calcMode: "spline",
				dur: "0.6s",
				keySplines: ".33,.66,.66,1;.33,0,.66,.33",
				values: "12;6;12"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 3,
			fill: "currentColor",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "cy",
				begin: "svgSpinners3DotsBounce0.begin+0.1s",
				calcMode: "spline",
				dur: "0.6s",
				keySplines: ".33,.66,.66,1;.33,0,.66,.33",
				values: "12;6;12"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 12,
			r: 3,
			fill: "currentColor",
			children: /* @__PURE__ */ _jsx("animate", {
				id: "svgSpinners3DotsBounce1",
				attributeName: "cy",
				begin: "svgSpinners3DotsBounce0.begin+0.2s",
				calcMode: "spline",
				dur: "0.6s",
				keySplines: ".33,.66,.66,1;.33,0,.66,.33",
				values: "12;6;12"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgBouncing3Dots);
export { ForwardRef as ReactComponent };
